import { api } from '@api'
import { SapGeo } from '@types'

interface SapGeoResponse {
  geos: SapGeo[]
}

const getSapGeo = async (companyShortName: string = 'AR') => {
  const response = await api
    .get<SapGeoResponse>(`/sap-geo?country=${companyShortName}`)
    .then(res => res.data)

  return response.geos
}

export const SapGeoApi = { getSapGeo }
